<fw-card>
  <fw-card-content>
    <header>
      <h4 class="annotation-label">
        {{annotation().label}}
        <span class="annotation-version">v{{annotation().version}}</span>
      </h4>
      <p>
        {{ annotation().elements.length | number }} Measurements
        <span>·</span>
        {{ (annotation().modified || annotation().created )| date:"M/d/yy 'at' hh:mm a" }}
      </p>
      @if(author()) {
        <div class="row author">
          <fw-avatar [appUser]="author()" size="small"></fw-avatar>
          <h6>{{author().email}}</h6>

          @if(annotation().task_id) {
            <span> · </span>
            <a [routerLink]="['/', 'tasks', 'reader', annotation().task_id]">View Task</a>
          }
        </div>
      }
    </header>
    @if (annotation().metrics?.by_label) {
      <section class="measurement-list">
        @for (measurement of annotation().metrics?.by_label || []; track $index) {
          @if($index < 5 || showMore) {
            <div class="measurement">
              <h5>{{measurement.label || 'Unlabeled'}}</h5>
              <div class="row">
                <fw-badge [value]="measurement.count | number" variant="static"></fw-badge>
                <p>{{formatMeasurement(measurement)}}</p>
              </div>
            </div>
          }
        }
        @if (!showMore && annotation().metrics.by_label.length > 5 ) {
          <div class="measurement">
            <p>Showing 5 of {{annotation().metrics.by_label.length}}</p>
            <div class="row">
              <p class="show-more" aria-role="button" (click)="showMore = true">Show All</p>
            </div>
          </div>
        }
      </section>
    }
  </fw-card-content>
</fw-card>
